export default __webpack_public_path__ + "static/media/ms_SQL.6f6aee25.png";